// Lead-magnet form handler. On submit, prevents navigation and swaps the
// submit button into a confirmation state. Wired via `[data-lead-magnet]`
// instead of the original inline onsubmit handler.
export default function initLeadMagnet() {
  const forms = document.querySelectorAll("[data-lead-magnet]")
  if (!forms.length) return

  forms.forEach((form) => {
    form.addEventListener("submit", (e) => {
      e.preventDefault()
      const btn = form.querySelector('button[type="submit"]')
      if (!btn) return
      btn.textContent = "Verstuurd! Check je inbox."
      btn.classList.remove("bg-flame-500", "hover:bg-flame-600")
      btn.classList.add("bg-emerald-500")
      btn.disabled = true
    })
  })
}
